import { IContentPlaylist } from './IContentPlaylist';

const VBRICKCONTENT_VALUE_SEPARATOR: string = ',';
const VBRICKCONTENT_RANGE_SEPARATOR: string = '_';

/**
 * If the sub-playlist is an absolute path, returns that. Otherwise, builds an absolute path from the master playlist url and the sub-playlist relative path / file name.
 * @param masterPlaylistUrl The full master playlist url.
 * @param subPlaylistFileNameOrUrl Sub-playlist url.
 */
export function getSubPlaylistUrl(masterPlaylistUrl: string, subPlaylistFileNameOrUrl: string, isMulticast?: boolean): string {
	return subPlaylistFileNameOrUrl.includes('://') ?
		subPlaylistFileNameOrUrl //absolute url
		: getSubPlaylistUrlFromRelative(masterPlaylistUrl, subPlaylistFileNameOrUrl, isMulticast); //relative
}

/**
 * The master playlist file name is replaced with the given relative sub-playlist path.
 * @param masterPlaylistUrl The full master playlist url.
 * @param relativePlaylistFileNameOrUrl A relative path to a sub-playlist (or file name).
 */
export function getSubPlaylistUrlFromRelative(masterPlaylistUrl: string, relativePlaylistFileNameOrUrl: string, isMulticast?: boolean): string {
	const masterPlaylistFileName: string = masterPlaylistUrl.split('/').pop();
	const [, queryStr] = masterPlaylistUrl.split('?');
	const queryToAppend: string = isMulticast && queryStr ?
		'?' + queryStr :
		'';

	return masterPlaylistUrl.replace(masterPlaylistFileName, relativePlaylistFileNameOrUrl + queryToAppend);
}

/**
 * Builds the expected content playlist mapping from the provided vbrickcontent tag values.
 * Example tag inputs:
 * 1) 45.678,content-mbr_45.m3u8
 * 2) 45.678_56.789,content-mbr_45.m3u8
 * A comma separates 2 top-level values: The active time range followed by the content playlist.
 * The range value always has a start time. An end time is optional (not present when content is live and active) and is seperated from the start time by an underscore (_).
 * @param tags Content playlist tag values from the speaker playlist of spec v4.
 * @param masterPlaylistUrl Full url for the master playlist. Used to derive urls for each of the relative content playlist files tagged.
 */
export function parseVbrickContentTags(tags: string[], masterPlaylistUrl: string, isMulticast: boolean): Map<string, IContentPlaylist> {
	return tags
		.reduce((output, current) => {
			const [range, playlist] = current.split(VBRICKCONTENT_VALUE_SEPARATOR);
			const [startStr, endStr] = range.split(VBRICKCONTENT_RANGE_SEPARATOR);

			output.set(startStr, {
				start: +startStr,
				end: endStr ? +endStr : null, //may not be present in live scenario
				url: getSubPlaylistUrl(masterPlaylistUrl, playlist, isMulticast)
			});

			return output;
		}, new Map<string, IContentPlaylist>());
}
